/**
 * Centralized class status constants and filters
 * This ensures consistent status handling across the application
 */

export const CLASS_STATUS = {
  SCHEDULED: 'Scheduled',
  COMPLETED: 'Completed',
  MISSED: 'Missed',
} as const;

export type ClassStatus = typeof CLASS_STATUS[keyof typeof CLASS_STATUS];

export const CLASS_STATUS_LIST: readonly ClassStatus[] = [
  CLASS_STATUS.SCHEDULED,
  CLASS_STATUS.COMPLETED,
  CLASS_STATUS.MISSED,
] as const;

/**
 * Status filters for different views
 * - LIST_VIEW: Shows all classes (Scheduled, Completed, Missed) in the list
 * - SLIDER_COUNT: Counts only Completed classes in the slider
 */
export const CLASS_STATUS_FILTERS = {
  LIST_VIEW: CLASS_STATUS_LIST, // Show all in list
  SLIDER_COUNT: [CLASS_STATUS.COMPLETED] as const, // Count only completed in slider
} as const;
